import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function formatDisplayDate(dateStr: string) {
  if (!dateStr) return ''
  const [year, month, day] = dateStr.split('T')[0].split('-')
  return `${day}.${month}.${year}`
}

export function formatDisplayPhone(value: string) {
  if (!value) return ''
  return parsePhoneNumberFromString(`+${value}`)?.formatInternational() ?? value
}
